import { cloneElement, memo, useEffect, useRef } from 'react';

import { ShadowDOMProps } from './ShadowDom.types';

export const ShadowDOM = memo(({ htmlContent, component, styles }: ShadowDOMProps) => {
  const containerRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    if (containerRef.current) {
      const shadowRoot = containerRef.current.shadowRoot || containerRef.current.attachShadow({ mode: 'open' });

      // Build the HTML content with optional styles
      let content = htmlContent;
      if (styles) {
        content = `<style>${styles}</style>${htmlContent}`;
      }

      shadowRoot.innerHTML = content;
    }
  }, [htmlContent, styles]);

  return cloneElement(component, { ref: containerRef });
});
